import { MuiX } from "@osu/react-ui";
import { Fragment } from "react/jsx-runtime";
import { actionsDataGridKey, columns, hiddenFields } from "./util/constants";
import { useGetAllFormsQuery } from "../../../services/form/api";
import { useDispatch, useSelector } from "react-redux";
import { selectFilterModel, selectSortModel, setFilterModel, setNextIDs, setSortModel } from "../../../services/form/slices";
import { useMemo, useState } from "react";
import BulkStatusUpdate from "./Renders/BulkStatusUpdate";
const { useGridApiRef } = MuiX;

let columnVisibilityModel = {};
Object.values(hiddenFields).forEach((field) => {
  columnVisibilityModel[field] = false;
});

const DataGrid = ({ year, type, isAdmin, ...props }) => {
  const apiRef = useGridApiRef()
  const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });
  const { data = [], isLoading: _isLoading, isFetching, refetch } = useGetAllFormsQuery(
    { year, type },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const isLoading = _isLoading || isFetching
  const dispatch = useDispatch();
  const sortModel = useSelector(selectSortModel);
  const filterModel = useSelector(selectFilterModel);
  const columnsWithApiRef = useMemo(
    () =>{
    return columns.map((col) => {
        if(col.field === actionsDataGridKey) {
          return {
            ...col,
            renderCell: (args) => {
              if(!col.renderCell) {
                return
              }
              const callback = () => {
                if(apiRef && dispatch) {
                  const latestRows = MuiX.gridFilteredSortedRowIdsSelector(apiRef)
                  dispatch(setNextIDs(latestRows))
                }
              }
              return col.renderCell({
                ...args,
                onFormPathClick: callback
              })
            }
          };
        }
        return col
      })},
    [apiRef, dispatch]
  );

  const selectedRows = useMemo(
    () => data.filter((row) => rowSelectionModel.ids.has(row.id)),
    [data, rowSelectionModel]
  );

  const handleBulkComplete = () => {
    setRowSelectionModel({ type: 'include', ids: new Set() });
    refetch();
  };

  return (
    <Fragment>
      {isAdmin && selectedRows.length > 0 && (
        <BulkStatusUpdate
          selectedRows={selectedRows}
          onComplete={handleBulkComplete}
        />
      )}
      <MuiX.DataGrid
        apiRef={apiRef}
        loading={isLoading}
        {...props}
        rows={data || []}
        columns={columnsWithApiRef}
        checkboxSelection={isAdmin}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={setRowSelectionModel}
        initialState={{
          columns: {
            columnVisibilityModel,
          },
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          }
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnResize={false}
        sortModel={sortModel}
        onSortModelChange={(model) => {
          dispatch(setSortModel(model))
        }}
        filterModel={filterModel}
        onFilterModelChange={(model) => {
          dispatch(setFilterModel(model))
        }}

      />
    </Fragment>
  );
}

export default DataGrid;
